import script from "./delete-office-modal.vue?vue&type=script&lang=js"
export * from "./delete-office-modal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__